import { Injectable } from '@angular/core';
import { DataService } from '@services/data.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ConfigState } from '@store/config.state';
import { Config } from '@other/interfaces';
import { CognosService } from '@services/cognos.service';
import { LogService } from '@services/log.service';
@Injectable()
export class AccessGranted implements CanActivate {

  @SelectSnapshot(ConfigState) config !: Config;

  constructor (
    private data: DataService,
    private router: Router,
    private logger: LogService,
    private _cognos: CognosService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.config.corpintra) {
      // Check user capabilities in Cognos Server
      // Check user capabilities in Cognos Server
      // FIX: Safely access capabilities to avoid "Cannot read properties of null"
      const capabilities = this._cognos.userCapabilities.getValue();
      const targetConfig = capabilities ? capabilities[this.config.target] : null;
      const hasAccess = targetConfig ? targetConfig[route.data.title] : false;

      // Now we can safely check access OR if it's a public route
      this.data.accessGranted = hasAccess || ['about','help'].includes(route.data.title);
      
      if (this.data.accessGranted) {
        this.logger.info("AccessGranted","canActivate", "accessGranted: "+this.data.accessGranted)
        return true;
      } else {
        this.logger.info("AccessGranted","canActivate", "accessGranted is false. Redirecting to /");
        return this.router.createUrlTree(['/'], { queryParamsHandling: 'merge' })
      }
    }
    if (location.href.includes('bypass') || location.hostname.includes('localhost') || localStorage.getItem('accessGranted') === 'yes') {
      this.data.accessGranted = true
      return true
    }
    if (!this.data.accessGranted) return this.router.createUrlTree(['miami-access'], { queryParamsHandling: 'merge' })
    return this.data.accessGranted
  }
}
